<div class="modal-header">
  <h4 class="modal-title pull-left">{{ title }}</h4>
</div>
<div class="modal-body">
  @if (loading$ | async) {
    <div class="loading-div">
      <mat-progress-spinner color="primary" mode="indeterminate" />
    </div>
  }
  <div>
    @if (text) {
      <div>{{ text }}</div>
      <br />
    }
    @if (htmlSrc) {
      <!-- sandbox is required: srcdoc bypasses Angular's HTML sanitizer -->
      <iframe width="100%" height="500px" style="border: 0" sandbox [title]="title" [srcdoc]="htmlSrc"></iframe>
    }
  </div>
</div>
<div class="modal-footer">
  <ng-container>
    @if (checkboxText) {
      <div class="mr-auto">
        <form class="form-horizontal" [formGroup]="form" autocomplete="off">
          <input type="checkbox" id="footerCheckbox" formControlName="checkbox" />
          <label for="footerCheckbox">{{ checkboxText | translate }}</label>
        </form>
      </div>
    }
    @if (button_cancel_text) {
      <button type="button" class="btn btn-secondary" (click)="onCancel()">
        {{ button_cancel_text }}
      </button>
    }
    @if (button_confirm_text) {
      <button type="button" class="btn btn-secondary" (click)="onConfirm()">
        {{ button_confirm_text }}
      </button>
    }
  </ng-container>
</div>
